import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

export const Posts = (props) => {

  const {
    posts,
    setIsLoading,
    category,
  } = props;

  return (
    <div className="posts">
      <div className="container contPosts">
        {posts?.length > 0 && posts.map((item, i) => {
          return (
            <div key={i} className="post">
              <div className="image">
                <div className="tag">
                  <span class="material-symbols-outlined">keyboard_double_arrow_right</span>
                  {item?.categoriaPost}
                </div>
                <img width="400" height="400" src={require(`./../../../../assets/post/img/${item?.imagePost}`)} alt="" />
              </div>
              <div className="info">
                <div className="title">
                  {item?.titoloPost.replace("${counter}", item?.counterProducts)}
                </div>
              </div>
              <NavLink
                className={({ isActive }) => isActive ? 'active' : ''}
                to={`/post/${item?.idPost}`}
                onClick={() => {
                  setIsLoading(true);
                  setTimeout(() => {
                    document.querySelector('html').scrollTo(0, 0);
                  }, 500);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};